import axios from 'axios'

const service = axios.create({
  baseURL: 'https://api.g-yorkies.com',
  timeout: 10000
})
service.interceptors.request.use(config => {
  config.headers['Accept'] = 'application/json'
  return config
},error => {
  console.log('err:',error) // for debug
  Promise.reject(error)
})

// Add a response interceptor
service.interceptors.response.use((response) => {
  console.log('api数据返回',response)
  // Do something with response data
  return response
}, (error) => {
  // Do something with response error
  return Promise.reject(error)
})

export default service
